import { getTheme } from '@fluentui/react';

const theme = getTheme();

export const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px',
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

export const surveyStyles = surveyMaxWidth => ({
  container: {
    padding: 24,
    maxWidth: surveyMaxWidth,
    fontFamily: 'Segoe UI',
    lineHeight: '20px',
  },
  header: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    '& .survey-close-button': {
      marginTop: 0,
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
  },
  body: {
    fontSIze: 14,
    color: '#000000',
    '& .asterisk': {
      color: '#A80000',
    },
  },
  ratingDescription: {
    fontWeight: 600,
  },
  rating: {
    '& label': {
      padding: 0,
      fontWewight: 'normal',
    },
    '& input': {
      visibility: 'hidden',
    },
  },
  ratingOption: {
    '& span.ms-ChoiceFieldLabel': {
      fontWeight: 400,
    },
  },
  area: {
    marginTop: 16,
  },
  areaDescription: {
    fontWeight: 600,
    marginBottom: 7,
  },
  areaCheckbox: {

  },
  areaComment: {
    marginTop: 6,
    marginLeft: 27,
  },
  comment: {
    marginTop: 16,
  },
  commentDescription: {
    fontWeight: 600,
  },
  commentInput: {
    marginTop: 8,
  },
  email: {
    marginTop: 16,
  },
  emailDescription: {
    fontWeight: 600,
  },
  emailOptions: {
    '& .ms-ChoiceField-wrapper': {
      width: '100%',
    },
  },
  emailOption: {
    '& span.ms-ChoiceFieldLabel': {
      fontWeight: 400,
    },
    '& label': {
      padding: 0,
    },
  },
  emailInput: {
    marginTop: 6,
    marginLeft: 26,
    marginBottom: 4,
  },
  emailError: {
    marginLeft: 26,
    color: '#A80000',
    lineHeight: '16px',
    fontSize: 12,
    fontWeight: 400,
    marginTop: 2,
  },
  footer: {
    fontSIze: 14,
    marginTop: 16,
    color: '#000000',
  },
  privacyStatement: {
    lineHeight: '16px',
    marginTop: 20,
    marginBottom: 20,
    fontSize: 12,
    color: '#605E5C',
  },
  infoText: {
    fontWeight: 600,
    textDecoration: 'underline',
  },
  validationError: {
    color: '#A80000',
    lineHeight: '16px',
    fontSize: 12,
    fontWeight: 400,
    marginTop: 2,
  },
  buttonBar: {
    float: 'right',
  },
  submitButton: {
    marginRight: 12,
  },
  cancelButton: {

  },
  closeButton: {

  },
});
